export default class LockScroll {
  constructor() {
    this.scroll = 0;
  }

  lock() {
    this.scroll = window.scrollY || window.pageYOffset;

    $('html')
      .addClass('_noscroll')
      .css({
        position: 'fixed',
        top: `-${this.scroll}px`,
        left: '0',
        right: '0',
        overflow: 'hidden',
        width: '100%',
      });
  }

  unlock() {
    $('html')
      .removeClass('_noscroll')
      .removeAttr('style');

    window.scrollTo(0, this.scroll);
  }
}


// WEBPACK FOOTER //
// ./_layout/js/LockScroll.js